"use client";

import { avenirNextMedium } from "@/styles/fonts";
import clsx from "clsx";
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css"; // Ensure styles are imported

type TooltipProps = {
    id: string;
    content: string;
    children: React.ReactNode;
};

const Tooltip: React.FC<TooltipProps> = ({ id, content, children }) => {
    return (
        <>
            <span data-tooltip-id={id} data-tooltip-content={content}>
                {children}
            </span>
            <ReactTooltip
                id={id}
                place="right"
                className={clsx(avenirNextMedium.className)}
                style={{
                    zIndex: 9999,
                    width: 300,
                    backgroundColor: "#fff",
                    padding: "20px 30px",
                    textAlign: "center",
                    fontSize: "17px",
                    color: "#666",
                    lineHeight: "24px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
                }}
            />
        </>
    );
};

export default Tooltip;